import _implicitStylesheets from "./tabs.css";
import _implicitScopedStylesheets from "./tabs.scoped.css?scoped=true";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h2 class="axwp-tabs__title${0}"${2}>${"t1"}</h2>`;
const $fragment2 = parseFragment`<button${"a0:aria-controls"}${"a0:aria-selected"} class="axwp-tabs__item-button${0}"${"a0:id"} role="tab"${"a0:tabindex"} type="button"${2}>${"t1"}</button>`;
const stc0 = {
  classMap: {
    "axwp-tabs": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "axwp-tabs__container": true
  },
  key: 3
};
const stc2 = {
  classMap: {
    "axwp-tabs__list-container": true
  },
  key: 4
};
const stc3 = {
  classMap: {
    "axwp-tabs__list": true
  },
  attrs: {
    "role": "tablist"
  },
  key: 5
};
const stc4 = {
  "axwp-tabs__item": true
};
const stc5 = {
  "role": "presentation"
};
const stc6 = {
  "type": "button"
};
const stc7 = {
  attrs: {
    "name": "tab-contents"
  },
  key: 10
};
const stc8 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, b: api_bind, gid: api_scoped_id, ti: api_tab_index, c: api_custom_element, h: api_element, i: api_iterator, s: api_slot} = $api;
  const {_m0, _m1, _m2, _m3, _m4} = $ctx;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.title))]), api_element("div", stc1, [api_element("div", stc2, [api_element("ul", stc3, api_iterator($cmp.tabs, function (tab) {
    return api_element("li", {
      classMap: stc4,
      attrs: stc5,
      key: api_key(6, tab.identifier)
    }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
      props: stc6,
      key: 7,
      on: {
        "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
      }
    }, [api_static_fragment($fragment2, 9, [api_static_part(0, {
      on: {
        "keydown": _m3 || ($ctx._m3 = api_bind($cmp.handleTabListKeyDown)),
        "click": _m4 || ($ctx._m4 = api_bind($cmp.handleTabClick))
      },
      attrs: {
        "aria-controls": api_scoped_id(tab.tabPanelId),
        "aria-selected": tab.active,
        "id": api_scoped_id(tab.identifier),
        "tabindex": api_tab_index(tab.tabIndex)
      }
    }, null), api_static_part(1, null, api_dynamic_text(tab.label))])])]);
  }))]), api_slot("tab-contents", stc7, stc8, $slotset)])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["tab-contents"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-367p61ao08v";
tmpl.legacyStylesheetToken = "undefined-_tabs";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
